import { defineMessages } from "react-intl"

export const messages = defineMessages({
    editLocationsHeader: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.header",
        defaultMessage: "Edit locations - {value}",
    },
    editLocationsUseForAll: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.use-for-all-unassigned",
        defaultMessage: "Use for all unassigned locations",
    },
    editLocationsUseForAllHint: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.use-for-all-unassigned-hint",
        defaultMessage:
        "By enabling this toggle, you’ll associate this payment account with all locations you have that are not linked to any payment accounts.",
    },
    editLocationsSelectLocations: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.select-locations",
        defaultMessage: "Use the following locations",
    },
    editLocationsSelectLocationsHint: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.select-locations-hint",
        defaultMessage:
    "You can choose multiple locations for this payment account.  However, locations already assigned to other payment accounts cannot be selected."},
    editLocationsSave: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.save",
        defaultMessage: "Save",
    },
    editLocationsClose: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.close",
        defaultMessage: "Close",
    },
    editLocationsUnassignedLocations: {
        id: "payment-processing.payment-account-listing.edit-locations-modal.unassigned_locations",
        defaultMessage: "Unassigned locations : {value}",
    },
})


// WEBPACK FOOTER //
// ./src/payment-processing/modals/EditLocationsMessages.ts